module.exports = __webpack_public_path__ + "img/icon-settings.3e6e00e5.svg";